// utils/postRequest.js — экспорт для Vite
/**
 * POST запрос с FormData/JSON, timeout и abort.
 * @param {string} url - Endpoint
 * @param {Object} params - Данные
 * @param {Object} [headers={}] - Доп. headers
 * @param {Object} [commonHeaders={}] - Общие headers (из Engine)
 * @param {number} [timeout=60000] - ms
 * @returns {Promise<{data: any, status: number}>}
 */
export async function postRequest(url, params, headers = {}, commonHeaders = {}, timeout = 60000) {
    const controller = new AbortController();  // Cancel
    const signal = controller.signal;

    // FormData или JSON
    let body;
    const hasJsonCt = headers['Content-Type'] === 'application/json';
    if (hasJsonCt) {
        body = JSON.stringify(params);
        headers['Content-Type'] = 'application/json';
    } else {
        body = new FormData();
        Object.entries(params).forEach(([key, value]) => body.append(key, value));
    }

    // Все headers
    const allHeaders = { ...commonHeaders, ...headers };

    const id = setTimeout(() => controller.abort(), timeout);

    try {
        const res = await fetch(url, {
            method: 'POST',
            headers: allHeaders,
            body,
            signal
        });

        clearTimeout(id);

        if (!res.ok) {
            throw new Error(`${res.status}: ${res.statusText}`);
        }

        // Авто-парсинг
        const contentType = res.headers.get('content-type');
        const data = contentType?.includes('application/json')
            ? await res.json()
            : await res.text();

        return { data, status: res.status };
    } catch (error) {
        clearTimeout(id);
        if (error.name === 'AbortError') {
            throw new Error('Request timeout');
        }
        throw error;
    }
}

// Глобал для legacy
window.postRequest = postRequest;